var map = {
	"./CSS3-logo.png": 9247,
	"./DOQUE.png": 5457,
	"./FootFusion.png": 2699,
	"./Git-Icon.png": 641,
	"./Github.png": 1430,
	"./JavaScript-logo.png": 9156,
	"./Python-logo.png": 9317,
	"./UOC.png": 9688,
	"./axios.png": 4405,
	"./bootstrap-logo.png": 9745,
	"./bridgeon.png": 4499,
	"./express-js.png": 4323,
	"./html5-logo.png": 4875,
	"./java-logo.svg": 7235,
	"./mongodb.svg": 2945,
	"./msahad.jpg": 1603,
	"./nextjs.png": 4977,
	"./node.png": 5095,
	"./nodejs-logo.svg": 4668,
	"./pinterest.png": 781,
	"./portfolio-logo.png": 6043,
	"./react.webp": 5042,
	"./redux.svg": 9761,
	"./sahad.jpg": 9752,
	"./tailwind-css.png": 221,
	"./tailwind.svg": 6581,
	"./typeScript.png": 5394,
	"./vscode-logo.png": 3837
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3907;